import { gsap, ScrollTrigger, scrollSmootherInstance } from "../globals/gsap";
// import imagesLoaded from "imagesloaded";
import { imagesLoaded } from "../utils/imagesLoaded";

class FullscreenIntro {
  fadoutDuration = 1;
  slider = {
    autoplaySpeed: 2,
  };
  stateClasses = {
    visible: "fullscreen-intro--visible",
    slideActive: "active",
    fadeOut: "fullscreen-intro--fade-out"
  };
  constructor($el) {
    this.$el = $el;
    this.$main = $("main");
    this.$slides = this.$el.find('[data-fullscreen-intro="slide"]');
    this.slideIndex = 0;
    this.$currentSlide = this.$slides.eq(this.slideIndex);
    this.$nextSlide = null;
    this.init();
  }

  init = () => {
    // console.log("inited", this);
    this.$el.addClass(this.stateClasses.visible);

    imagesLoaded(this.$el, () => {
      scrollSmootherInstance.paused(false);
      // play video if the first slide has a video
      const $video = this.$currentSlide.find("video");
  
      // bind scroll event
      $(window).one("scroll", this.eventHandler);
      this.$el.one("click", this.eventHandler);
  
      if (this.$slides.length > 1) {
        // create a infinite loop for the slider
        this.autoplay = setInterval(() => {
          this.slideNext();
        }, this.slider.autoplaySpeed * 1000);
      } else {
        this.$slides[0].classList.add(this.stateClasses.slideActive);
      }
  
      // play video if the first slide has a video
      if ($video.length) {
        const video = $video.get(0);
        video.play();
      }
    });
  };

  eventHandler = () => {
    this.fadeOut();
  }

  fadeOut = () => {
    this.autoplay = clearInterval(this.autoplay);
    scrollSmootherInstance.paused(true);
    const tl = gsap.timeline();
    this.$el.addClass(this.stateClasses.fadeOut);

    tl.to(this.$el, {
      duration: 0.5,
      clipPath: "inset(2.5% 2.5% 2.5% 2.5%)",
      ease: "cubic-bezier(.165,.84,.44,1)",
    });

    tl.to(this.$el, {
      duration: this.fadoutDuration,
      height: 0,
      ease: "cubic-bezier(.165,.84,.44,1)",
      onComplete: () => {
        ScrollTrigger.refresh();
        scrollSmootherInstance.paused(false);
        this.$el.remove();
      },
    });

    // unbind scroll & click event
    $(window).off("scroll", this.eventHandler);
    this.$el.off("click", this.eventHandler);
  };

  slideNext = () => {
    this.$currentSlide = this.$slides.eq(this.slideIndex);
    this.slideIndex++;
    if (this.slideIndex >= this.$slides.length) {
      this.slideIndex = 0;
    }

    this.$nextSlide = this.$slides.eq(this.slideIndex);

    this.$currentSlide.removeClass(this.stateClasses.slideActive);
    this.$nextSlide.addClass(this.stateClasses.slideActive);

    // check if the next slide has a video
    const $nextVideo = this.$nextSlide.find("video");

    if ($nextVideo.length) {
      const video = $nextVideo.get(0);
      video.currentTime = 0;
      video.play();
    }

    // check if the current slide has a video
    const $currentVideo = this.$currentSlide.find("video");

    if ($currentVideo.length) {
      const video = $currentVideo.get(0);
      video.pause();
    }
  };
}

export default FullscreenIntro;
